import { ActionTypesScreenCommon } from "app/constants";

export const defaultState = {
  orientationHorizontal: false,
  displayDataSources: false,
};

function ScreensCommonReducer(state = defaultState, action) {
    switch (action.type) {
      case ActionTypesScreenCommon.CHANGE_ORIENTATION:
        return { ...state, orientationHorizontal: !state.orientationHorizontal };
      case ActionTypesScreenCommon.DISPLAY_DATA_SOURCES:
        return { ...state, displayDataSources: !state.displayDataSources };
      case ActionTypesScreenCommon.LOG_USER_ACTIVITY:
        return state;
      default:
        return state;
    }
  }
  
  export default ScreensCommonReducer;